import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import RadioCheck from '../RadioCheck';
import type { RadioCheckProps } from '../RadioCheck';
import type { RefElement } from '../../types';
import { useTestIds } from '../../hooks';
import { withTestIds } from '../../utils';

import { getRadioButtonTestIds } from './RadioButton.test-ids';

// Use Omit here to avoid listing all props for HTMLInputElement.
// eslint-disable-next-line @typescript-eslint/ban-types
export type RadioButtonProps = Omit<RadioCheckProps, 'type'>;

const RadioButton = forwardRef<RefElement<RadioButtonProps>, PropsWithoutRef<RadioButtonProps>>(
  function RadioButton({ testId, ...restProps }, ref) {
    const testIds = useTestIds(testId, getRadioButtonTestIds);

    return <RadioCheck {...restProps} testId={testIds} type='radio' ref={ref} />;
  }
);

export default withTestIds(RadioButton, getRadioButtonTestIds);
